import React from 'react';
import * as styles from './UploadRestriction.module.scss';
import { useAppDispatch } from '../app/redux/useAppSelector';
import UpgradeButton from '../organization/UpgradeButton';
import getFeature from '../utils/features';
import { openPricingModal } from '../utils/url/pricingPath';

const UploadRestriction = () => {
  const dispatch = useAppDispatch();

  const handleUpgradeClick = () => {
    openPricingModal(dispatch, 'uploadSize');
  };

  return (
    <div>
      <div className={styles.message}>
        Your team’s maximum upload size is {getFeature('attachment_size_limit')}
        MB. Upgrade to increase your limit.
      </div>
      <UpgradeButton onClick={() => handleUpgradeClick()}>
        View upgrade options
      </UpgradeButton>
    </div>
  );
};

export default UploadRestriction;
